import React from "react";

const CookiePolicy = () => {
  const handleScroll = (event) => {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute("href");
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="LegalsPage">
      <div className="cookies-policy">
        <h1 className="cookie-policy-heading">Cookie Policy</h1>
        <p>
          <i>
            <i>Last Updated: May 15, 2023</i>
          </i>
        </p>

        <p>
          Please read the following carefully to understand how yslearn.in (a
          11326953 Canada Inc, company, also “yslearn”, “we”, or “us”) uses
          Cookies and other tracking technologies when you visit{" "}
          <a href="https://www.yslearn.in/" target="_blank" rel="noreferrer">
            www.yslearn.in
          </a>
          (the “Site”). By using or accessing our Site, you agree to this
          Cookie Policy. This Cookie Policy may change from time to time and
          your continued use of the Site is deemed to be acceptance of such
          changes. Please check this Cookie Policy periodically for updates.
        </p>

        <h2>QUICK GUIDE TO CONTENTS</h2>

        <ul>
          <li>
            <a href="#heading1" onClick={handleScroll}>
              <h4>What are Cookies?</h4>
            </a>
          </li>
          <li>
            <a href="#heading2" onClick={handleScroll}>
              <h4>How You Can Control or Delete Cookies</h4>
            </a>
          </li>
          <li>
            <a href="#heading3" onClick={handleScroll}>
              {" "}
              <h4>Control via Your Browser Settings</h4>
            </a>
          </li>
          <li>
            <a href="#heading4" onClick={handleScroll}>
              <h4>Additional Mechanisms for Exercising Choice</h4>
            </a>
          </li>
          <li>
            <a href="#heading5" onClick={handleScroll}>
              {" "}
              <h4>Types of Cookies Used by yslearn</h4>
            </a>
          </li>
          <li>
            <a href="#heading6" onClick={handleScroll}>
              {" "}
              <h4>Cookies Set by Members</h4>
            </a>
          </li>
          <li>
            <a href="#heading7" onClick={handleScroll}>
              {" "}
              <h4>Questions/Contact Us</h4>
            </a>
          </li>
        </ul>

        <ol>
          <li className="for-heading-li">
            <h3 id="heading1">What are Cookies?</h3>
          </li>
          <p>
            Cookies and similar tracking technologies (e.g., pixel tags and
            HTML5 storage objects) (collectively "Cookies") are files containing
            small amounts of information that are stored by your browser on any
            Internet-enabled device – such as your computer, smart phone, or
            tablet – when you visit a website. Most web pages contain elements
            from multiple web domains, so when you visit our Site, your browser
            may receive Cookies from several sources.
          </p>
          <br />
          <p>
            Cookies are then sent back to the originating website on each
            subsequent visit, or to another website that recognizes that cookie.
            Cookies do lots of different and useful jobs, such as remembering
            your actions and preferences (such as login, language, font size and
            other display preferences), distinguishing you from other users of
            the Site, generally improving your online experience, and helping us
            to offer you the best product and services. We use Cookies and other
            tracking technologies to ensure visitors to our Site have the best
            possible experience and to provide targeted advertising.
          </p>
          <li className="for-heading-li">
            <h3 id="heading2">How You Can Control or Delete Cookies</h3>
          </li>

          <p>We provide you with several ways to manage Cookies:</p>
          <ul>
            <li>
              You can refuse to provide your consent to our collection of
              non-essential Cookies;
            </li>
            <li>
              You can disable first- or third-party Cookies by use of your
              browser settings;
            </li>
            <li>
              You can use opt-out tools provided by the Digital Advertising
              Alliance (DAA), European Interactive Digital Advertising Alliance
              (EDAA), or National Advertising Initiative (NAI).
            </li>
          </ul>
          <p>
            Our performance, functionality and targeting/advertising Cookies are
            not strictly necessary for the Site to work but will provide you
            with a better browsing experience. You can delete or block these
            Cookies, but if you do this, you may have to manually adjust some
            preferences every time you visit the Site and some features of the
            Site may not work as intended. For example, you may not be able to
            visit certain areas of the Site or you may not receive personalized
            information when you visit our Site.
          </p>

          <li className="for-heading-li">
            <h3 id="heading3">Control via Your Browser Settings</h3>
          </li>

          <p>
            Most internet browsers are initially set up to automatically accept
            Cookies. If you do not want our Site to store Cookies on your
            computer or device, you can change or adjust your browser or device
            settings to block Cookies or to alert you when Cookies are being
            sent to your device.
          </p>
          <p>
            If you use different devices to view and access our Site (e.g. your
            computer, smartphone, tablet, etc.), you will need to ensure that
            each browser on each device is adjusted to suit your Cookie
            preferences.
          </p>
          <p>
            The procedures for changing your settings and Cookies differ from
            browser to browser. If necessary, use the help function on your
            browser or click on one of the links below to go directly to the
            user manual for your browser.
          </p>

          <ul>
            <li>
              <a
                href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
                target="_blank" rel="noreferrer"
              >
                Disable Cookies in Internet Explorer
              </a>
            </li>
            <li>
              <a
                href="https://support.google.com/chrome/answer/95647?hl=en"
                target="_blank" rel="noreferrer"
              >
                Disable Cookies in Chrome
              </a>
            </li>
            <li>
              <a
                href="https://support.apple.com/en-in/guide/safari/sfri11471/mac"
                target="_blank" rel="noreferrer"
              >
                Disable Cookies in Safari
              </a>
            </li>
            <li>
              <a
                href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectlocale=en-US&redirectslug=enable-and-disable-cookies-website-preferences"
                target="_blank" rel="noreferrer"
              >
                Disable Cookies in FireFox
              </a>
            </li>
            <li>
              <a
                href="https://support.apple.com/en-gb/HT201265"
                target="_blank" rel="noreferrer"
              >
                Disable Cookies in Safari IOS
              </a>
            </li>
            <li>
              <a
                href="https://support.google.com/chrome/answer/114662?hl=en&ref_topic=3422740&visit_id=1-636650043021695599-602656146&rd=1"
                target="_blank" rel="noreferrer"
              >
                Disable Cookies in Google Android
              </a>
            </li>
          </ul>

          <p>
            <b>More info.</b> To find out more about Cookies, including how to
            see what Cookies have been set and how to manage and delete them,
            visit{" "}
            <a href="https://www.aboutcookies.org/" target="_blank" rel="noreferrer">
              aboutcookies.org
            </a>
            or{" "}
            <a href="https://www.allaboutcookies.org/">allaboutcookies.org.</a>
          </p>

          <li className="for-heading-li">
            <h3 id="heading4">Additional Mechanisms for Exercising Choice</h3>{" "}
          </li>
          <p>
            We, or other parties we do business with, may place or recognize
            unique Cookies placed on your browser or use other tracking
            technologies when you visit our Site to collect information about
            your use of the Site and your other online activities over time and
            across different websites and apps, and may use that information to
            serve interest-based advertisements to you as you browse the
            Internet.
          </p>
          <p>
            To learn more about your choices for receiving interest-based
            advertising or to opt-out, please review the information below:
          </p>
          <ul>
            <li>
              <b>DAA:</b> To opt-out of such collection and use for
              interest-based advertising by the Digital Advertising Alliance
              (DAA) participating companies, please visit the{" "}
              <a
                href="https://optout.aboutads.info/?c=2&lang=EN"
                target="_blank" rel="noreferrer"
              >
                DAA's website.
              </a>
            </li>
            <li>
              <b>EDAA:</b> To opt-out from the use of information about your
              online activities for interest-based advertising by European
              Interactive Digital Advertising Alliance (EDAA) member companies,
              please visit the{" "}
              <a href="https://youronlinechoices.eu/" target="_blank" rel="noreferrer">
                EDAA's website.
              </a>
            </li>
            <li>
              <b>NAI:</b> To opt-out from the use of information about your
              online activities for interest-based advertising by Network
              Advertising Initiative (NAI) member companies, please visit the{" "}
              <a
                href="https://optout.networkadvertising.org/?c=1"
                target="_blank" rel="noreferrer"
              >
                NAI's website.
              </a>
            </li>
          </ul>

          <p>
            Please note that even if you opt-out, you may still receive
            advertisements from yslearn that are not customized based on Cookies
            or other technologies.
          </p>

          <li className="for-heading-li">
            <h3 id="heading5">Types of Cookies Used by yslearn</h3>
          </li>
          <p>
            We use different types of Cookies to run our Site. Some or all of
            the Cookies identified below may be stored in your browser.
          </p>
          <p>
            <b>Strictly Necessary Cookies</b>
          </p>
          <p>
            Strictly Necessary Cookies are necessary for the operation of our
            Site. These Cookies are essential in helping you to move around our
            Site and use the features, such as accessing secure areas of the
            Site or using the shopping basket.
          </p>

          <p>For example, we may use Strictly Necessary Cookies to:</p>

          <ul>
            <li>
              Remember the goods and services you selected when you get to the
              payment page
            </li>
            <li>Identify you as being logged into the Site</li>
            <li>Provide access to protected areas of the Site</li>
            <li>
              Remember previously entered text so it is not lost if the page
              refreshes
            </li>
          </ul>

          <p>
            <b>Performance Cookies</b>
          </p>
          <p>
            Performance Cookies simply help us improve the way our Site works.
            We utilize these Cookies to analyze how our visitors use our Site
            and to monitor our site performance. They tell us how people use
            each page, which ones are most commonly viewed, or whether any
            errors occurred. This allows us to provide a high-quality experience
            and quickly identify then fix any issues that arise.
          </p>
          <p>For example, we may use Performance Cookies to:</p>
          <ul>
            <li>
              Store preferences to see which method of linking between pages is
              most effective
            </li>
            <li>
              Enable web analytics to provide anonymous statistics on how our
              Site is used
            </li>
            <li>
              To assist with error management in helping us improve the Site by
              measuring any errors that occur
            </li>
            <li>
              Monitor ad response rates and determine the effectiveness of our
              ads
            </li>
          </ul>

          <p>
            <b>Functionality Cookies</b>
          </p>
          <p>
            We use Functionality Cookies to allow us to remember your
            preferences. For example, we may use Functionality Cookies to:
          </p>
          <ul>
            <li>
              Remember settings you have applied such as layout, colors, font
              sizes and page backgrounds
            </li>
            <li>
              Remember if we have already asked you if you want to fill in a
              survey
            </li>
            <li>
              Detect if you have already seen a pop-up to ensure it doesn’t get
              shown to you again
            </li>
            <li>
              Process a request from a user to submit a comment or blog or forum
              post
            </li>
          </ul>

          <p>
            <b>Targeting Cookies</b>
          </p>
          <p>
            Targeting Cookies help yslearn make sure that the ads you see on our
            Site are relevant to you and your interests. Targeting Cookies may
            also be placed on your device by our third party service providers
            that remember you have visited the Site in order to provide you with
            ads more relevant to you. We may use Targeting Cookies to:
          </p>
          <ul>
            <li>
              Collect information about browser habits to target advertising
            </li>
            <li>
              Collect information about browser habits to target site content
            </li>
            <li>Provide links to social networks</li>
            <li>
              Provide advertising agencies with information on your visit so
              that they can present you with advertisements you may be
              interested in
            </li>
          </ul>

          <p>
            Many of the Cookies placed through our Site are session Cookies,
            while others are persistent Cookies, and some are “first-party”
            Cookies, while others are “third-party” Cookies.
          </p>
          <ul>
            <li>
              <b>First-party Cookies</b> are those set by a site that is being
              visited by the user at the time (e.g., Cookies placed by{" "}
              <a href={`${process.env.REACT_APP_SMIK_API_BASEURL}`} target="_blank" rel="noreferrer">
                www.yslearn.in
              </a>{" "}
              ).
            </li>
            <li>
              <b>Third-party Cookies</b> are Cookies that are set by a domain
              other than that of the site being visited by the user. For
              example, when a user visits a site and a cookie set on that site
              by a third-party fires, it transfers information to the user's web
              browser, where it might be stored or sent back with the next
              request to the same server. Cookies that are sent through these
              third-party components are called third-party cookies and are
              mainly used for advertising and tracking across the web.
            </li>
            <li>
              <b>Persistent Cookies</b> are Cookies that remain on a user’s
              device for the period of time specified in the cookie. They are
              activated each time that the user visits the site that created
              that particular cookie.
            </li>
            <li>
              <b>Session Cookies</b> are Cookies that allow website operators to
              link the actions of a user during a browser session. A browser
              session starts when a user opens the browser window and finishes
              when they close the browser window. Session Cookies are created
              temporarily. Once you close the browser, all session Cookies are
              deleted.
            </li>
            <li>
              <b>Google Analytics Cookies.</b> Our Site uses Google Analytics
              Cookies, which monitor traffic levels, search queries and visits
              to our Site. These Cookies enable Google to determine whether you
              are a return visitor to the Site and to track the pages that you
              visit during your session. For more information about Google
              Analytics Cookies, please see
              <a
                href="https://policies.google.com/privacy?hl=en"
                target="_blank" rel="noreferrer"
              >
                Google's privacy policy.
              </a>{" "}
              Google has developed the Google Analytics opt-out browser add-on
              for the Google Analytics JavaScript (ga.js, analytics.js, dc.js).
              If you want to opt out of Google Analytics, you can download and
              install{" "}
              <a
                href="https://tools.google.com/dlpage/gaoptout?hl=en"
                target="_blank" rel="noreferrer"
              >
                Google’s add-on for your web browser.
              </a>
            </li>
            <li>
              <b>Facebook Advertisements.</b> We use Facebook to market our
              services, track conversion events, and find audiences for our
              courses, programs, and products. You can control whether you see
              ads based on your activity off of Facebook, through “Data About
              Your Activity From Partners” in your Facebook
              <a
                href="https://www.facebook.com/help/247395082112892"
                target="_blank" rel="noreferrer"
              >
                Ad Preferences.
              </a>
              For more information, see Facebook’s
              <a
                href="https://www.facebook.com/help/568137493302217?helpref=faq_content"
                target="_blank" rel="noreferrer"
              >
                help page.
              </a>
            </li>
          </ul>

          <li className="for-heading-li">
            <h3 id="heading6">Cookies Set by Members</h3>
          </li>
          <p>
            Some of the educational institutions or other leading global
            entities that create courses and/or programs using tools provided by
            yslearn and offer them directly to you through the Site (“Members”)
            set Cookies within those courses and/or programs, and those Members
            alone choose which Cookies to set. However, your Cookie consent
            choices on the Site will apply to Cookies set by Members.
          </p>

          <li className="for-heading-li">
            <h3 id="heading7">Questions/Contact Us</h3>{" "}
          </li>
          <p>
            If you have any questions or concerns regarding this Cookie Policy,
            please contact us at{" "}
            <a href="mailto:support@yslearn.in">support@yslearn.in.</a>
          </p>
        </ol>
      </div>
    </div>
  );
};

export default CookiePolicy;
